import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Loader from '../../../core/ui/utility/Loader';
import {
  PerformanceAppearanceEdit,
  PerformanceAppearance,
} from '../performanceAppearance';
import EditPerformanceAppearanceForm from '../components/EditPerformanceAppearanceForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import { parseFormQuery } from '../../../core/utils/utility';

const EditPerformanceAppearanceContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [performanceAppearance, setPerformanceAppearance] =
    useState<PerformanceAppearance | null>(null);

  const fetchPerformanceAppearance = () =>
    fetchData(`auth-bana29/performance-appearances/${id}`, {
      onSuccess: (data: PerformanceAppearance) => {
        setPerformanceAppearance(data);
      },
    });

  useEffect(() => {
    fetchPerformanceAppearance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: PerformanceAppearanceEdit,
    { setFieldError }: FormikHelpers<PerformanceAppearanceEdit>
  ) => {
    const formData: any = parseFormQuery(values, []);

    await callApi({
      endpoint: `auth-bana29/performance-appearances/${id}`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'application/json',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchPerformanceAppearance();
        toastMessage('PerformanceAppearance Edited');
      },
    });
  };

  return (
    <Layout
      renderLeftToolbar={() => <ReturnButton to="/performance-appearances" />}
    >
      <Loader loading={loading || !performanceAppearance}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">View Performance Appearance</Typography>
          </Grid>
          <EditPerformanceAppearanceForm
            performanceAppearance={performanceAppearance!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditPerformanceAppearanceContainer;
